import React, { useState } from "react";

import { QuickFilter, InfiniteTable, SortDropdown } from "../../components";
import { UsersTabs, HeaderCard } from "../../views/Users/index.jsx";
import { Link, useHistory } from "react-router-dom";

import { MerchantRow } from "../molecules";

const headers = [" ", " ", "Name", "Merchant ID", "Subscription", "Expiry"];

export function MerchantsList() {
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({});
  const [filterValue, setFilterValue] = useState("created_at|desc");

  return (
    <div>
      <main id="contacts" className="flex-grow-1">
        <div className="d-none d-md-block mb-3">
          <UsersTabs />
        </div>

        <div className="container center-container">
          <HeaderCard setFilters={setFilters} />
          <div className="d-flex justify-content-start flex-wrap mt-4 p-3 pb-0 p-md-0 justify-content-md-between">
            <QuickFilter
              className="contacts d-none d-md-block"
              placeholder="Quick search for users"
              onUpdate={(query) => setSearchQuery(query)}
            />
          </div>

          <div className="p-3 mb-4 mt-4 list-container">
            <div className="d-flex justify-content-between list-toolbar">
              <SortDropdown
                onChange={(v) => setFilterValue(v.value)}
                options={[
                  { value: "created_at|desc", label: "Last Created" },
                  { value: "turnover|asc", label: "Turnover: Low To High" },
                  {
                    value: "turnover|desc",
                    label: "Turnover: High To Low",
                  },
                  {
                    value: "last_purchase|desc",
                    label: "Last purchase: New first",
                  },
                  {
                    value: "last_purchase|asc",
                    label: "Last purchase: Old first",
                  },
                ]}
                placeholder={"Top Users"}
                value={filterValue}
              />

              <Link to="/users/create">
                <button className="create create-small d-xl-none" />
                <button className="create d-none d-xl-block">
                  Create a new User
                </button>
              </Link>
            </div>
            <InfiniteTable
              className="contacts mobile-alternative"
              fetchUrl="/api/merchants"
              responsive={false}
              fetchParams={{
                query: searchQuery,
                filters,
              }}
              fetchLimit={25}
              emptyText="No merchants found."
              headers={headers}
              onSelectClick={() => {}}
              RowComponent={MerchantRow}
            />
          </div>
        </div>
      </main>
    </div>
  );
}
